"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSendPrompt = void 0;
const react_1 = require("react");
const ModalContext_1 = require("../../context/ModalContext");
const adminApiUtil_1 = require("../adminApiUtil");
const textUtil_1 = require("../textUtil");
let hookGlobalAbort = null;
const useSendPrompt = () => {
    const context = (0, react_1.useContext)(ModalContext_1.ModalContext);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const generateNew = (prompt) => {
        const action = {
            userPrompt: prompt,
        };
        sendPrompt(false, action);
    };
    const editCurrent = (prompt) => {
        const oldResponse = (0, textUtil_1.getCurrentResponse)(context.responses, context.showResponseIndex);
        const action = {
            userPrompt: oldResponse.userPrompt,
            editPrompt: prompt,
            prevAnswer: oldResponse.answer,
        };
        sendPrompt(true, action);
    };
    const retryCurrent = () => {
        const oldResponse = (0, textUtil_1.getCurrentResponse)(context.responses, context.showResponseIndex);
        sendPrompt(true, {
            userPrompt: oldResponse.userPrompt,
            editPrompt: oldResponse.editPrompt,
            prevAnswer: oldResponse.prevAnswer,
        });
    };
    const stopRequest = () => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        hookGlobalAbort && hookGlobalAbort();
        hookGlobalAbort = null;
    };
    const sendPrompt = (clearRedo = false, additionalData = {}) => {
        stopRequest();
        context.updateState({ loadingResponse: true });
        setLoading(true);
        const responses = clearRedo
            ? context.responses.slice(0, context.showResponseIndex + 1)
            : [...context.responses];
        const requestBody = Object.assign({ promptId: context.promptId, objectLabel: context.objectLabel, 
            // userPrompt: prompt && !edit ? prompt : context.userPrompt,
            entityType: context.entityType, entityId: context.entityId, text: context.targetContent }, additionalData);
        const newReponse = {
            userPrompt: requestBody.userPrompt,
            editPrompt: requestBody.editPrompt,
            prevAnswer: requestBody.prevAnswer,
        };
        let firstChunk = true;
        const request = (0, adminApiUtil_1.getPromptStreamResponse)(requestBody, (val) => {
            const newState = {
                responses: [...responses, Object.assign(Object.assign({}, newReponse), { answer: val })],
            };
            if (firstChunk) {
                firstChunk = false;
                newState.showResponseIndex = responses.length;
            }
            context.updateState(newState);
        });
        hookGlobalAbort = request.abort;
        request.promise
            .catch((reason) => {
            if (reason instanceof adminApiUtil_1.LlmResponseError) {
                alert(reason.message);
            }
        })
            .finally(() => {
            context.updateState({ loadingResponse: false });
            setLoading(false);
        });
    };
    return { generateNew, editCurrent, retryCurrent, stopRequest, loading };
};
exports.useSendPrompt = useSendPrompt;
